import React from "react";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormRenderer from "Common/Custom/FormRenderer";

/**
 * EditSalaryGenerateForm
 * 
 * Flow for mapping json fields to form edit layout
 */
const EditSalaryGenerateForm = ({
    fields = {},
    values = {},
    handleChange = () => { },
    handleSubmit = () => { },
    loading = false,
    errors = {},
    optionConfig = {},
    title = "Edit Salary Generate"
}) => {

    return (
        <PageBody
            card={true}
            onSubmit={handleSubmit}
            headerchildren={<HeadingOne>{title}</HeadingOne>}
        >
            {/* Dynamic rendering from JSON configuration */}
            <FormRenderer
                fields={fields.formdata || []}
                values={values}
                errors={errors}
                handleChange={handleChange}
                optionConfig={optionConfig}
            />

            <div className="mt-4">
                <FormSubmitButton
                    label="Update Salary Batch"
                    loading={loading}
                    colSize="auto"
                />
            </div>

        </PageBody>
    );
};

export default EditSalaryGenerateForm;
